import { createFileRoute } from '@tanstack/react-router'
import { EditVaccinePage } from '_/features/pets/ui/pages/edit-vaccine-page'

const EditVaccineRoute = () => {
	const { petId, vaccineId } = Route.useParams()
	return <EditVaccinePage petId={petId} vaccineId={vaccineId} />
}

export const Route = createFileRoute('/_authenticated/pets/$petId/vaccines/$vaccineId/edit')({
	staticData: { title: 'vaccines_edit_title' },
	component: EditVaccineRoute,
})
